import { useCallback } from 'react';
import { Box, Flex } from '@mantine/core';
import { IconDownload, IconFileFilled, IconTrash } from '@tabler/icons-react';

import { Button, Text } from 'components';

interface IAttachmentItem {
  creditRequestId: number;
  item: any;
  removeFile: (val: any) => void;
}

const AttachmentItem = ({
  creditRequestId,
  item,
  removeFile,
}: IAttachmentItem) => {

  const preview = () => window.open(`${process.env.REACT_APP_API_URL_ATTACHMENTS}/credit-request/${creditRequestId}/${item.id}.${item.extension}`, '_blank', 'noopener,noreferrer');

  const downloadFile = useCallback(() => {
    const link = document.createElement('a');
    link.href = `${process.env.REACT_APP_API_URL_ATTACHMENTS}/credit-request/${creditRequestId}/${item.id}.${item.extension}`;
    link.download = item.name + '.' + item.extension;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, []);

  return (
    <Flex align={'center'} justify={'space-between'} mb={4}>
      <Flex>
        <IconFileFilled color={'var(--mantine-color-primary-6)'} size={24} style={{ marginBottom: 4, cursor: 'pointer' }} onClick={item.id ? preview : undefined} />
        <Text ml={6}>{item.name}</Text>
      </Flex>
      <Box style={{ textAlign: 'end', flexGrow: 1 }}>
        {item.id ?
          <Button
            variant={'transparent'}
            size={'compact-sm'}
            mb={4}
            onClick={downloadFile} 
          >
            <IconDownload size={20}/>
          </Button>
        : undefined}
        {!item.id ?
          <Button
            variant={'transparent'}
            size={'compact-sm'}
            color={'var(--mantine-color-error)'}
            mb={4}
            ml={4}
            onClick={() => removeFile(item)}
          >
            <IconTrash size={20} />
          </Button>
        : undefined}
        </Box>
    </Flex>
  )
}

export default AttachmentItem;